import React from 'react';
import ReactDOM from 'react-dom';

import { store, persistor, sagaMiddleware } from 'redux/store';
import rootSaga from 'redux/sagas';
import * as serviceWorker from './serviceWorker';

import App from './App';
import './index.css';

sagaMiddleware.run(rootSaga);

ReactDOM.render(<App store={store} persistor={persistor} />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
